module.exports = __webpack_public_path__ + "media/bootstrap-icons/tag-fill-55bef10c.svg";